export default "__VITE_ASSET__ixua9cU$__"